module.exports = __webpack_public_path__ + "img/chisudeshizi.ab3688db.jpg";